import * as React from "react";
import { Row } from "react-bootstrap";

export default Row;
